import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { FormGroup, Table } from "@cofano/cck";
import ShipSelect from "view/ships/components/selects/ShipSelect";
import { RelationSchemaInput, RelationSchemaOutput } from "view/relations/utils/relation.schema";
import { ShipFragment } from "__generated__/view/ships/graphql/ship.fragments.generated";

const RelationShipsForm = ({ identifier, getOptionDisabled } : {
	identifier: "managedShips" | "operatorShips";
} & Pick<Parameters<typeof ShipSelect>[0], "getOptionDisabled">) => {

	const { control } = useFormContext<RelationSchemaInput, unknown, RelationSchemaOutput>();

	const ships = useWatch({ control, name: identifier });

	return (
		<React.Fragment>
			<FormGroup
				label={identifier === "managedShips" ? intl.formatMessage({ id: "SHIP_MANAGER_SHIPS" }) : intl.formatMessage({ id: "OPERATORS_SHIPS" })}
				labelPlacement="left-center"
				overflow="hidden">
				<Controller
					name={identifier}
					control={control}
					render={({ field }) => (
						<ShipSelect
							{...field}
							getOptionDisabled={getOptionDisabled}
							multiple />
					)} />
			</FormGroup>

			<RelationShipsTable ships={ships ?? []} />
		</React.Fragment>
	);
};

export const RelationShipsTable = ({ ships }: {
	ships: Pick<ShipFragment, "id" | "name" | "eni" | "mmsi">[]
}) => (
	<Table
		id="relationShipsTable"
		content={ships}
		columns={[ {
			id: "name",
			title: intl.formatMessage({ id: "SHIPS_NAME" }),
		}, {
			id: "eni",
			title: intl.formatMessage({ id: "SHIP_ADD_ENI" }),
		}, {
			id: "mmsi",
			title: intl.formatMessage({ id: "SHIP_ADD_MMSI" }),
		} ]}
		disableFooter />
);

export default RelationShipsForm;
